/* eslint-disable */
<template>
	<section>
		<div>
			<div class="columns">
				<div class="column is-half">
					ich habe email
					<input class="input" type="text" v-model="email" placeholder="Text input">
					ich habe telefonnummer
					<input
						class="input"
						type="text"
						v-model="telephone"
						placeholder="Text input"
					>
				</div>
				<div class="column is-half"></div>
			</div>
			<router-link :to="{ name: 'summary'}">
				<button class="button" v-on:click="requestContact">Weiter</button>
			</router-link>
		</div>
		<div v-if="false">

			<div class="columns">
				<div class="column is-half">
					Geben Sie code ein
					<input class="input" type="text" v-model="email" placeholder="Text input">
					ich habe telefonnummer
					<input
						class="input"
						type="text"
						v-model="telephone"
						placeholder="Text input"
					>
				</div>
				<div class="column is-half"></div>
			</div>
			<router-link :to="{ name: 'summary'}">
				<button class="button" v-on:click="requestVerification">Weiter</button>
			</router-link>
		</div>
	</section>
</template>
<script>
import axios from 'axios'

export default {
	name: 'ForgotCode',

	components: {},
	computed: {},
	data () {
		return {
			status: {}
		}
	},

	created () {
		// this.fetchData();
	},

	methods: {
		requestContact () {
			axios
				.post(process.env.API_URL + '/forgot-code', {
					email: this.email,
					telephone: this.telephone
				})
				.then(response => {
					this.status = response.data
				})
				.catch(err => {
					console.log(err)
				})
		},
		requestVerification () {
			axios.post(
				process.env.API_URL + '/forgot-code/verification',
				{ verification_code: this.verification_code }
			)
				.then(response => {
					this.status = response.data
					if (this.status.status == 'ok') {

						// PRINT NEW CODE
					} else {
						// something wrong
					}
				})
				.catch(err => {
					console.log(err)
				})
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/ForgotCode.vue